import { api } from '../../../utility/apiClient';

export const FORM_KEY = 'product_feedback';

// ── User endpoints ────────────────────────────────────────────────────────────

/** GET /api/v1/feedback/forms/active?page=1&limit=20 — returns active forms list */
export const getActiveForms = ({ page = 1, limit = 20, sort_order = 'desc' } = {}) => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('limit', String(limit));
  params.set('sort_order', sort_order);
  return api.get(`/api/v1/feedback/forms/active?${params.toString()}`);
};

/** GET /api/v1/feedback/forms/:key/active — returns form + active version + questions */
export const getActiveForm = (key = FORM_KEY) =>
  api.get(`/api/v1/feedback/forms/${key}/active`);

/** POST /api/v1/feedback/forms/:key/submissions */
export const submitFeedback = (payload, key = FORM_KEY) =>
  api.post(`/api/v1/feedback/forms/${key}/submissions`, payload);

/** GET /api/v1/feedback/my-submissions?form_key=optional&page=1&limit=20 */
export const getMySubmissions = ({ formKey, page = 1, limit = 20 } = {}) => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('limit', String(limit));
  if (formKey) params.set('form_key', formKey);
  return api.get(`/api/v1/feedback/my-submissions?${params.toString()}`)
    .catch((err) => { throw new Error(err.message || 'Failed to fetch your submissions.'); });
};

// ── Admin endpoints ───────────────────────────────────────────────────────────

/** GET /api/v1/feedback/forms */
export const getForms = () =>
  api.get('/api/v1/feedback/forms')
    .catch((err) => { throw new Error(err.message || 'Failed to fetch forms.'); });

/** POST /api/v1/feedback/forms — creates form + version 1 */
export const createForm = (data) =>
  api.post('/api/v1/feedback/forms', data)
    .catch((err) => { throw new Error(err.message || 'Failed to create form.'); });

/** POST /api/v1/feedback/forms/:formId/versions — copies questions from active if none given */
export const createVersion = (formId, data = {}) =>
  api.post(`/api/v1/feedback/forms/${formId}/versions`, data)
    .catch((err) => { throw new Error(err.message || 'Failed to create version.'); });

/** PUT /api/v1/feedback/versions/:versionId/questions — replaces full question list */
export const updateVersionQuestions = (versionId, questions) =>
  api.put(`/api/v1/feedback/versions/${versionId}/questions`, { questions })
    .catch((err) => { throw new Error(err.message || 'Failed to update questions.'); });

/** POST /api/v1/feedback/versions/:versionId/publish */
export const publishVersion = (versionId) =>
  api.post(`/api/v1/feedback/versions/${versionId}/publish`)
    .catch((err) => { throw new Error(err.message || 'Failed to publish version.'); });

/** GET /api/v1/feedback/submissions?page=1&limit=25 */
export const getSubmissions = ({ page = 1, limit = 25 } = {}) => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('limit', String(limit));
  return api.get(`/api/v1/feedback/submissions?${params.toString()}`)
    .catch((err) => { throw new Error(err.message || 'Failed to fetch submissions.'); });
};

